var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "page-detail" }, [
    _c(
      "section",
      [
        _c(
          "v-row",
          { attrs: { variant: "flex", vertical: "start" } },
          [
            _c("v-column", { attrs: { large: 3, phone: 12 } }, [
              _c("aside", { staticClass: "page-detail__aside" }, [
                _c("nav", { staticClass: "page-detail__nav" }, [
                  _c(
                    "ul",
                    { staticClass: "page-detail__ul" },
                    _vm._l(_vm.data, function(item) {
                      return _c(
                        "li",
                        {
                          key: item.slug,
                          class: [
                            "page-detail__li",
                            {
                              "page-detail__li--active":
                                item.slug === _vm.activeCategory
                            }
                          ]
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "page-detail__link",
                              attrs: {
                                to: {
                                  name: "helpDetail-" + _vm.$i18n.locale,
                                  params: { slug: item.slug }
                                }
                              }
                            },
                            [
                              _c("v-typo", {
                                attrs: {
                                  "data-hovered": "true",
                                  variant: "body-paragraph"
                                },
                                domProps: { innerHTML: _vm._s(item.headline) }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("v-column", { attrs: { large: 9, phone: 12 } }, [
              _c(
                "section",
                { staticClass: "page-detail__main" },
                [
                  _vm.activeCategoryData
                    ? _c("v-accordion-group", {
                        ref: "accordion",
                        attrs: { data: _vm.activeCategoryData, name: "help" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("v-contact-us")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }